import React, { Component } from "react";
import IssueDetailsSideBar from "./IssueDetailsSideBar";
import AddIssue from "../createProjectAddIssueForm/AddIssue";
import IssueListWitLoader from "../IssueListWithLoader/IssueListingWithLoader";
import { getIssueDetails } from "../../actions/issueDetail.action";
import {
  createIssueAction,
  isIssueDuplicatedAction
} from "../../actions/issues.action";
import {
  uploadFileAction,
  removeFileAction,
  getIssueList
} from "../../actions/common.action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MOM from "../MOM/MOM";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import { get } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import PointingArrow from "../../assets/pointing-arrow.svg";
import { LoaderPage } from "../../component/Loader";
import {
  dateFormat,
  getColor,
  modifyDataOfAddIssue,
  dayAgo,
  isValidArray,
  replaceCharacterWith,
  GROUP_KEYS,
  ScrollToView,
  validateDuplicatedIssue,
  PromisesHelper,
  transformProjectCategoryId,
  getLocalstorage
} from "../../helper";
import {
  STATUS,
  PATHS,
  ERROR_MSG,
  ISSUE_STATUS,
  ISSUE_DECISION_DETAILS
} from "../../constant";
import { postCommentAction } from "../../actions/issuesListAction.actions";
import { upcomingMOM } from "../../actions/mom.action";
import IssueAction from "../issueList/IssueActions";
import { IssueDetailLoader } from "../../component/LoadersTemplate";
import ProjectDetailWithLoader from "../projectDetails/ProjectDetailWithLoader";
import { toast } from "react-toastify";
import EditIssue from "../createProjectAddIssueForm/EditIssue";
import DisplayByPermission from "../../component/DisplayByPermission";
import PermissionHOC from "../PermissionHOC";
import { ConfirmationComponent } from "../ConfirmationComponent";
import Pagination from "../Pagination";
import { issueListParams as params } from "./helper";
import queryString from "query-string";
import {
  getProjectDetails,
  getProjectTimelineData
} from "../../actions/projectDetail.action";
import { withRouter } from "react-router-dom";
import {
  PreNode,
  ReadMore,
  IssueReadMore,
  DisplayAttachments,
  DisplayPopUpAttachments,
  RedirectUser,
  NoteComponent
} from "../reusableComponent";
import ForwardToTeamChilds from "../issueList/forwardToTeamChilds";
import { successToastStyle, errorToastStyle } from "../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
import introJs from "intro.js";
import "intro.js/introjs.css";
import LinkContext from "./LinkContext";
import NewPencilIcon from "../../assets/Union.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import IssueUpdateStatus from "../issueList/IssueUpdateStatus";
import MarkDuplicatebtn from "./MarkDuplicatebtn";
import { getPermissionsListing } from "../../services/apiServices";
import request from "../../services/requestService";
import TooltipComponent from "../../component/TooltipComponent";
import { IssueNoteModal } from "./IssueNoteModal";
import { EscalationLevelModal } from "../reusableComponent/EscalationLevel/EscalationLevelModal";
import IssuePragatiReview from "../prgatiReview/IssuePragatiReview";
import { toolttipDisplayMessage } from "../issueList/helper";
import AgendaIssuePragatiReview from "../prgatiReview/AgendaIssuePragatiReview";
import { ReadMoreContent } from "../reusableComponent/readMore/readMoreContent";
import PariveshData from "../pariveshData";
import AgendaIssuePragatiPipeline from "../prgatiReview/AgendaIssuePragatiPipeline";

const MESSAGES_CONSTANT = {
  EditIssue: "Edit issue details"
};
const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
class IssueDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLanguageError: true,
      files: [],
      error: {},
      upcomingMOM: [],
      issueListLoading: STATUS.LOADING,
      issueIdStatus: false,
      paginationNo: 0,
      issueListParams: { ...params },
      issueSaved: false,
      awakeSideBar: false,
      pageLoading: true,
      initialRequiredFields: [
        "groupCategory",
        "issueCategoryId",
        "issueSubCategoryId",
        "issueDescription",
        "recipientGroupId",
        "title",
        "selectedStateId",
        "selectedMinistryId",
        "issueSubCategoryId",
        "responsibleAuthority",
        "stateDistrictAndDepartment"
      ],
      decisionCount: null,
      displayButtons: 0,
      markbtndisplay: 0,
      admincredential: true,
      isPariveshModalVisible: false,
      selectedIssueSubCategoryId: null,
      selectedProposalNoParivesh: null,
      isProposalValidated: false
    };
    this.issueListContainer = React.createRef();
    this.linkRef = React.createRef();
    this.decisionRef = React.createRef();
    //const LinkContext = createContext();
  }
  handleButtonClose = data => {
    this.setState({ displayButtons: data });
  };

  handleProposalChange = proposal => {
    this.setState({ isProposalValidated: proposal });
  };

  componentDidMount = async () => {
    const response = await request(getPermissionsListing());
    const data = response.data.data.find(
      item => item.name === "updateProjectStatus"
    );
    if (data == undefined) {
      this.setState({ admincredential: true });
    } else if (data.name == "updateProjectStatus") {
      this.setState({ admincredential: false });
    } else {
      this.setState({ admincredential: true });
    }

    const { getIssueDetails, getProjectDetails, history } = this.props;
    const { issueId, projectId } = this.getQueryParams();
    let isIssueDetailCalled = false;
    if (issueId) {
      this.handleUpcomingMOM(+issueId);
      getProjectDetails(undefined, { id: +projectId }).then(resp => {
        if (resp && !resp.status) {
          if (!isIssueDetailCalled) {
            history.push(PATHS.ISSUE_LIST);
          }
        }
        resp && resp.data && this.getIssueListData();
      });
      this.setState(
        {
          isIssueDetailLoading: STATUS.LOADING
        },
        async () => {
          const resp = await getIssueDetails(undefined, { issueId: +issueId });
          if (resp && !resp.status) {
            history.push(PATHS.ISSUE_LIST);
            isIssueDetailCalled = true;
          }
          this.setState({
            issueData: resp,
            isIssueDetailLoading: STATUS.SUCCESS
          });

          this.checkDecision();
        }
      );
    }
  };
  componentWillReceiveProps = nextProps => {
    const {
      location: { search: newSearch },
      getIssueDetails
    } = nextProps;
    const {
      location: { search: oldSearch }
    } = this.props;

    const { issueId: newIssueId } = newSearch
      ? queryString.parse(newSearch)
      : {};
    const { issueId: oldIssueId } = oldSearch
      ? queryString.parse(oldSearch)
      : {};
    if (oldIssueId != newIssueId) {
      this.setState(
        {
          isIssueDetailLoading: STATUS.LOADING
        },
        async () => {
          this.handleUpcomingMOM(newIssueId);
          const resp = await getIssueDetails(undefined, {
            issueId: newIssueId
          });
          ScrollToView(this.issueWrapper);
          this.setState({
            isIssueDetailLoading: STATUS.SUCCESS,
            issueData: resp
          });
          this.checkDecision();
        }
      );
    }
  };
  initialApiCall = () => {
    const { getProjectDetails, location } = this.props;
    const { projectId } = queryString.parse(location.search);
    getProjectDetails(undefined, { id: +projectId });
  };

  awakeSideBar = () => {
    this.setState({
      awakeSideBar: true
    });
  };

  getIssueListData = (params = {}) => {
    try {
      const { projectId } = this.getQueryParams();
      const { issueListParams } = this.state;
      const { projectData } = this.props;
      let data = get(projectData, "data", null);
      let isProjectAwardedByState =
        data && data.sponsoredByCategory === GROUP_KEYS.STATE;
      this.setState(
        {
          issueListApiStatus: STATUS.LOADING,
          issueListDTO: null
        },
        async () => {
          const response = await getIssueList(undefined, {
            ...issueListParams,
            ...params,
            projectDetail: true,
            projectId,
            groupCategory: isProjectAwardedByState
              ? GROUP_KEYS.STATE
              : GROUP_KEYS.CENTRAL
          });
          if (response) {
            const { status, message, data } = response;
            if (status) {
              this.setState({
                issueListDTO: data,
                issueListApiStatus: STATUS.SUCCESS,
                issueListParams: { ...issueListParams, ...params }
              });
            } else {
              this.setState({
                issueListApiStatus: STATUS.ERROR,
                issueListDTO: data
              });
            }
          }
        }
      );
    } catch (e) {
      console.log("Error while fetching error", e);
    }
  };

  handleUpcomingMOM = async id => {
    const response = await upcomingMOM(undefined, { id });
    const { status } = response || {};
    status && this.setState({ upcomingMOM: response });
  };

  handleOnClick = event => {
    if (this.addIssueWrapper) {
      this.addIssueWrapper.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  };
  handleMarkBTN = data => {
    // console.log(data)
    this.setState({ markbtndisplay: data }, () => {
      //  console.log(this.state.markbtndisplay)
    });
  };
  updateParentState = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  updateParentStateError = (key, value) => {
    this.setState(prevState => {
      return {
        error: {
          ...prevState.error,
          [key]: value
        }
      };
    });
  };

  getCharactersBeforeHyphen = str => {
    // Split the string at the hyphen using the split() method
    const parts = str.split("-");

    // Return the first part (before the hyphen) using index 0
    return parts[0];
  };

  getQueryParams = () => {
    const {
      location: { search }
    } = this.props;
    const { projectId, issueId } = queryString.parse(search);
    return { projectId, issueId };
  };

  onSubmit = () => {
    const { createIssueDispatch, projectData } = this.props;
    const { projectId } = this.getQueryParams();
    let isProjectAwardedByState =
      get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
    try {
      this.setState({ issueSubmitted: STATUS.LOADING }, async () => {
        const modifyData = modifyDataOfAddIssue(
          this.state,
          isProjectAwardedByState
        );
        const response = await createIssueDispatch(undefined, {
          issueCOList: modifyData,
          projectId
        });
        if (response) {
          const { message, status } = response;
          (status &&
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            )) ||
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          this.openConfirmationAlert();
          this.setState(
            prevState => ({
              issueSubmitted: STATUS.SUCCESS,
              resetForm: true,
              issueCOList: [],
              error: {
                ...prevState.error,
                issueCOListError: null,
                issuesError: []
              }
            }),
            () => {
              this.getIssueListData();
              this.initialApiCall();
              this.setState({
                resetForm: false,
                issueSaved: true
              });
            }
          );
        }
      });
    } catch (e) {
      console.log("issue detail page", e);
    }
  };

  /*     validate form    */
  onValidateForm = async errorarug => {
    const { issueData, projectData } = this.props;
    const { error, initialRequiredFields } = this.state;

    const errorObj = { ...error };
    const mandatoryFields = [];
    let isProjectAwardedByState =
      get(projectData, "data.sponsoredByCategory") === GROUP_KEYS.STATE;
    this.setState({ showLanguageError: false });

    if (!isValidArray(errorObj.issueCOListError)) {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
      this.setState({
        error: {
          issueCOListError: [
            {
              error: true,
              required_field: initialRequiredFields
            }
          ],
          issuesError: [
            {
              error: true,
              required_field: initialRequiredFields
            }
          ]
        }
      });
    } else {
      if (isValidArray(errorObj.issueCOListError)) {
        // this.setState({
        //   error: {
        //     issueCOListError: [
        //       {
        //         error: false
        //         //required_field: initialRequiredFields
        //       }
        //     ],
        //     issuesError: [
        //       {
        //         error: false
        //         //required_field: initialRequiredFields
        //       }
        //     ]
        //   }
        // });
        mandatoryFields.push("issueCOListError");
      }

      let invalidForm = false;
      mandatoryFields.forEach(fieldKey => {
        let value = get(errorObj, fieldKey);

        if (!invalidForm) {
          invalidForm = get(value, "error");
        }

        if (fieldKey === "issueCOListError") {
          let issueList = get(errorObj, "issueCOListError");
          errorObj["issuesError"] = issueList.map(value => {
            if (!Object.keys(value).length || value.error) {
              invalidForm = true;
            }
            return value;
          });
        }
      });

      if (!invalidForm && errorObj.issueCOListError) {
        this.setState({
          error: errorObj
        });
        const isDuplicatedIssueExist = validateDuplicatedIssue(
          this.state.issueCOList
        );
        if (get(isDuplicatedIssueExist, "error")) {
          toast.error(
            <p className="toast-text-alignment">
              {get(isDuplicatedIssueExist, "message")}
            </p>,
            errorToastStyle
          );
        } else {
          const modifyIssue = modifyDataOfAddIssue(
            this.state,
            isProjectAwardedByState
          );
          const promiseArr =
            isValidArray(modifyIssue) &&
            modifyIssue.map(issue => {
              issue.projectId = get(issueData, "data.projectId");
              return isIssueDuplicatedAction(undefined, issue);
            });
          this.setState({ isApiLoading: true });
          const resp = await PromisesHelper(promiseArr);
          if (isValidArray(resp)) {
            let isFormInvalid = false;
            for (let index = 0; index <= resp.length - 1; index++) {
              if (get(resp[index], "data") && !isFormInvalid) {
                isFormInvalid = true;
                break;
              }
            }
            if (isFormInvalid) {
              toast.error(
                <p className="toast-text-alignment">
                  {ERROR_MSG.DUPLICATED_ISSUES_IN_PROJECT}
                </p>,
                errorToastStyle
              );
            } else {
              this.openConfirmationAlert();
            }
            this.setState({ isApiLoading: false });
          }
        }
      } else {
        this.setState({
          error: errorObj
        });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
          errorToastStyle
        );
      }
    }
  };

  onRemoveFile = async () => {
    const { initialRequiredFields } = this.state;

    this.setState({
      error: {
        issueCOListError: [
          {
            error: false,
            required_field: initialRequiredFields
          }
        ],
        issuesError: [
          {
            error: false,
            required_field: initialRequiredFields
          }
        ]
      }
    });
  };

  resetAddIssue = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value,
        issuesError: value
      }
    }));
  };

  addIssueErrorUpdate = value => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        issueCOListError: value
      }
    }));
  };

  onChange = (value, key) => {
    this.setState({
      [key]: value
    });
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  getIssueDetail = () => {
    const { getIssueDetails, history } = this.props;
    const { issueId } = this.getQueryParams();

    this.setState({ isIssueDetailLoading: STATUS.LOADING }, async () => {
      const resp = await getIssueDetails(undefined, { issueId });
      const { status } = resp;
      if (!status) {
        history.push(PATHS.ISSUE_LIST);
      }
      this.setState(
        {
          isIssueDetailLoading: status ? STATUS.SUCCESS : STATUS.ERROR,
          resetAction: true,
          issueData: resp
        },
        () => {
          this.setState({
            resetAction: false
          });
        }
      );
      this.checkDecision();
    });
  };

  onShow = () => {
    localStorage.setItem("DisplayButton", "0");
    this.setState(prevState => ({
      showEdit: !prevState.showEdit
    }));
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert
    }));
  };

  onPageChange = param => {
    this.getIssueListData({ offset: param.selected });
    this.issueListContainer &&
      this.issueListContainer.current.scrollIntoView({
        behavior: "smooth"
      });
  };
  onMouseclick = () => {
    window.addEventListener("keyup", event => {
      this.setState({
        showLanguageError: true
      });
    });
  };

  redirectToIssueDetails = event => {
    if (this.issueWrapper) {
      this.issueWrapper.scrollIntoView({
        behavior: "smooth"
      });
    }
    this.setState({
      pageLoading: false
    });
  };

  checkDecision() {
    const { issueData, decisionCount } = this.state;
    let data = get(issueData, "data", null);
    let _meetingDecisionDTOS = isValidArray(get(data, "meetingDecisionDTOS"))
      ? get(data, "meetingDecisionDTOS").filter(
          item => item.decisionStatus !== "DRAFT"
        )
      : null;
    let meetingDecisionsCount = isValidArray(_meetingDecisionDTOS)
      ? _meetingDecisionDTOS.length
      : 0;
    this.setState({
      decisionCount: meetingDecisionsCount
    });
  }

  // handleAfterChange = (targetElement) => {
  //   const highlightedElement = document.querySelector('.introjs-helperLayer');
  //   introJs().exit();
  // }

  startIntroTour = () => {
    let intoText =
      this.state.decisionCount == 1
        ? `There is ${
            this.state.decisionCount
          } Meeting Decision associated with this issue.`
        : `There are ${
            this.state.decisionCount
          } Meeting Decisions associated with this issue.`;
    introJs()
      .setOptions({
        showBullets: false,
        showButtons: false,
        autoPosition: false,
        scrollToElement: false,
        //scrollTo: this.decisionRef.current,
        //  disableInteraction: true,
        steps: [
          {
            element: this.decisionRef.current,
            intro: `${intoText} Click on Decisions for more details!`,
            position: "bottom-middle-aligned",
            tooltipClass: "decisionTooltip"
          }
          // ... other steps
        ]
      })
      .start();
    //this.decisionRef.current.scrollTo(0, 0);
    if (this.issueWrapper) {
      this.issueWrapper.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  isChild() {
    const isChild = true;
  }

  showPraiveshModal = () => {
    const { issueData } = this.state;
    let data = get(issueData, "data", null);
    const issueSubcategoryId = get(data, "issueSubcategoryId", null);
    const proposalNoParivesh = get(data, "proposalNoParivesh", null);
    this.setState({
      isPariveshModalVisible: true,
      selectedIssueSubCategoryId: issueSubcategoryId,
      selectedProposalNoParivesh: proposalNoParivesh
    });
  };
  closePariveshModal = () => {
    this.setState({
      isPariveshModalVisible: false
    });
  };

  render() {
    // redirect page on project list
    const {
      projectDetailsStatus,
      projectData,
      permission,
      loading,
      getProjectTimelineData
    } = this.props;
    // get project id
    const { issueId, projectId } = this.getQueryParams();
    // redirect page
    if (!issueId) {
      return <Redirect to={PATHS.ISSUE_LIST} />;
    }

    const {
      error,
      initialRequiredFields,
      showEdit,
      showAlert,
      resetForm,
      issueData,
      resetAction,
      upcomingMOM,
      paginationNo,
      issueListDTO,
      issueSubmitted,
      issueListParams,
      isImageUpLoading,
      issueListApiStatus,
      isIssueDetailLoading,
      issueSaved,
      awakeSideBar,
      isPariveshModalVisible,
      isProposalValidated
    } = this.state;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    let data = get(issueData, "data", null);
    //const issueSubcategoryId = get(data, "issueSubcategoryId", null);
    //const proposalNoParivesh = get(data, "proposalNoParivesh", null);
    const isPragatiReview = get(data, "issuePragatiReview");
    const isPragatiPipeline = get(data, "issuePragatiPipeLine");
    const te = get(data, "id");
    console.log(
      "issueId",
      te,
      "isPragatiReview",
      isPragatiReview,
      "isPragatiPipeline",
      isPragatiPipeline
    );

    //console.log("data here", data, issueSubcategoryId, proposalNoParivesh);
    const status = replaceCharacterWith(
      get(data, "issueStatusName", "NA"),
      "_",
      " "
    );
    // remove loaded issue id from issue list
    let listDTO = get(issueListDTO, "listDTO", []).filter(function(item) {
      return item.id !== +issueId;
    });

    let _meetingDecisionDTOS = isValidArray(get(data, "meetingDecisionDTOS"))
      ? get(data, "meetingDecisionDTOS").filter(
          item => item.decisionStatus !== "DRAFT"
        )
      : null;

    const projectPPList = get(projectData, "data.projectPPList", []);
    const createdBy =
      projectPPList && projectPPList.length ? projectPPList[0] : null;
    return (
      <React.Fragment>
        {isIssueDetailLoading === STATUS.SUCCESS &&
          this.state.pageLoading &&
          this.redirectToIssueDetails()}
        {this.state.showLanguageError === false && this.onMouseclick()}
        <div className="content no-sidebar">
          <ProjectDetailWithLoader
            isLoading={projectDetailsStatus}
            handleOnClick={this.handleOnClick}
            callApiOnSuccess={() => {
              this.initialApiCall();
              this.getIssueDetail();
              this.getIssueListData();
            }}
            toggle={false}
          />

          <ConfirmationComponent
            show={showAlert}
            isLoading={issueSubmitted}
            modalClass={"confirmation-modal"}
            saveHandler={this.onSubmit}
            closeHandler={this.openConfirmationAlert}
          />
          <LoaderPage
            loading={
              loading === STATUS.LOADING ||
              isIssueDetailLoading === STATUS.LOADING ||
              isImageUpLoading === STATUS.LOADING ||
              isProposalValidated
            }
          />
          <DisplayByPermission display={showEdit}>
            <div className="edit-issue">
              <EditIssue
                show={showEdit}
                isEdit={true}
                handleClose={this.onShow}
                callApiOnSuccess={() => {
                  this.getIssueDetail();
                  this.initialApiCall();
                }}
                issueId={issueId}
                workflowType={get(projectData, "data.workflowType")}
                projectPPList={get(projectData, "data.projectPPList")}
                handleProposalChange={this.handleProposalChange}
              />
            </div>
          </DisplayByPermission>
          <div className="issue-detail-wrapper" id="issue-wrapper-id">
            <Container
              ref={elem => {
                this.issueWrapper = elem;
              }}
            >
              <Row>
                {(isIssueDetailLoading === STATUS.LOADING && (
                  <Col lg={8} className="issue-detail">
                    <IssueDetailLoader
                      parentClass="loader-project-list"
                      times={1}
                    />
                  </Col>
                )) || (
                  <Col lg={8} className="issue-detail">
                    <div className="issue-detail-inner">
                      <div className="row">
                        <div className="col-md-9">
                          <div className="issue-list-header">
                            <div style={{ marginBottom: 15 }}>
                              <span
                                className={`issue-number ${
                                  get(data, "duplicate")
                                    ? "duplicate-issue-number"
                                    : ""
                                }`}
                              >
                                {get(data, "duplicate")
                                  ? "Duplicate Issue"
                                  : "Issue"}
                                <b>
                                  {" "}
                                  {/**CR 99 Changes Starts */}
                                  {get(data, "childIssue") === true ? (
                                    <>
                                      {get(data, "isUserOfGroup") === true ? (
                                        <>
                                          #
                                          {this.getCharactersBeforeHyphen(
                                            get(
                                              data,
                                              "projectIssueDTO.displayId"
                                            )
                                          )}
                                          -{get(data, "projectId")}-
                                          {get(data, "parent")}/
                                          {get(data, "id")}
                                        </>
                                      ) : (
                                        <>
                                          #
                                          {this.getCharactersBeforeHyphen(
                                            get(
                                              data,
                                              "projectIssueDTO.displayId"
                                            )
                                          )}
                                          -
                                          <Link
                                            to={{
                                              pathname: PATHS.ISSUE_DETAIL,
                                              search: `?issueId=${get(
                                                data,
                                                "parent"
                                              )}&&projectId=${get(
                                                data,
                                                "projectId"
                                              )}`
                                            }}
                                          >
                                            {get(data, "projectId")}-
                                            {get(data, "parent")}
                                          </Link>
                                          /{get(data, "id")}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      #{get(data, "projectIssueDTO.displayId")}-
                                      {get(data, "id")}
                                    </>
                                  )}
                                  {/**CR 99 Changes Ends */}
                                </b>
                              </span>
                              {/** CR 289 Changes Start-Yajnadutta*/}
                              {get(data, "escalationLevelName", "NA") ==
                              null ? null : (
                                <EscalationLevelModal
                                  IssueId={get(data, "id")}
                                  EscalationName={get(
                                    data,
                                    "escalationLevelName",
                                    "NA"
                                  )}
                                  pragatiDetailPage={true}
                                />
                              )}
                              {/**CR 289 Changes End -Yajnadutta**/}
                              <h2 className="issue-list-title">
                                <ReadMore
                                  clamp={
                                    data &&
                                    get(data, "title").match(/[\u0900-\u097F]/)
                                      ? "none"
                                      : 20
                                  }
                                  displayExpandButtons={false}
                                  content={htmlToFormattedText(
                                    get(data, "title", "NA")
                                  )}
                                  lineHeightTitle={1.3}
                                />
                              </h2>
                              <div>
                                {get(data, "childIssue") === true && (
                                  <div className="pt-2 pb-3">
                                    <img src={PointingArrow} />{" "}
                                    <span className="creator-text">
                                      Forwarded by
                                    </span>{" "}
                                    <RedirectUser
                                      title={get(
                                        data,
                                        "issueForwardedByName",
                                        "NA"
                                      )}
                                      id={get(data, "issueForwardedById", "NA")}
                                      isIssueForwarded={true}
                                      isMilestonePPDetail={true}
                                    />{" "}
                                    <span className="creator-text">
                                      on{" "}
                                      {dateFormat(
                                        get(data, "createdDate", null)
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <p className="issue-recipient">
                            <span
                              className="issue-recipient-title"
                              style={{ fontFamily: "mpb", color: "#000" }}
                            >
                              Recipient{" "}
                              {transformProjectCategoryId(
                                get(data, "recipientGroupCategory")
                              )}{" "}
                              -{" "}
                            </span>
                            <b
                              style={{
                                color: "#E65A32",
                                fontFamily: "mpsb"
                              }}
                            >
                              {get(data, "recipientGroup", "NA")}
                            </b>
                          </p>
                          {get(data, "districtName") ? (
                            <p
                              className="issue-recipient"
                              style={{
                                width: "107%",
                                color: "#E65A32",
                                fontFamily: "mpsb"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{ fontFamily: "mpb", color: "#000" }}
                              >
                                {get(data, "recipientLabel")} -{" "}
                              </span>
                              {get(data, "districtName", "NA")}
                            </p>
                          ) : null}
                          {get(data, "responsibleAuthority") ? (
                            <p
                              className="issue-sub-category"
                              style={{
                                color: "#E65A32",
                                fontFamily: "mpsb"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpb",
                                  color: "#000"
                                }}
                              >
                                Responsible Authority -{" "}
                              </span>
                              <span
                                className={`${
                                  get(data, "responsibleAuthority", "NA") !=
                                    null &&
                                  get(data, "responsibleAuthority", "NA").match(
                                    /[\u0900-\u097F]/
                                  )
                                    ? "hindi-text-wrap"
                                    : ""
                                }`}
                              >
                                {get(data, "responsibleAuthority", "NA")}
                              </span>
                            </p>
                          ) : null}
                          {get(data, "secondaryState") ||
                          get(data, "secondaryRecipientGroupName") ? (
                            <p
                              className="issue-sub-category"
                              style={{
                                color: "#E65A32",
                                fontFamily: "mpsb"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{ fontFamily: "mpb", color: "#000" }}
                              >
                                Secondary Recipient -{" "}
                              </span>
                              {get(data, "secondaryState", "NA") ||
                                get(data, "secondaryRecipientGroupName", "NA")}
                            </p>
                          ) : get(data, "secondaryMinistry") ? (
                            <p
                              className="issue-sub-category"
                              style={{
                                color: "#E65A32",
                                fontFamily: "mpsb"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{ fontFamily: "mpb", color: "#000" }}
                              >
                                Secondary Recipient -{" "}
                              </span>
                              {get(data, "secondaryMinistry", "NA")}
                            </p>
                          ) : null}
                          {get(projectData, "data.sponsoredByCategory") ===
                          "STATE" ? null : (
                            <p
                              className="issue-recipient"
                              style={{
                                width: "78%",
                                fontFamily: "mpr",
                                color: "#2E2E2E"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Issue Location-{" "}
                              </span>
                              {get(data, "centerState")}
                            </p>
                          )}
                          {/* {get(data, "centerState") ? (
                            <p
                              className="issue-recipient"
                              style={{
                                width: "78%",
                                fontFamily: "mpr",
                                color: "#2E2E2E"
                              }}
                            >
                              <span
                                className="issue-category-title"
                                style={{ fontFamily: "mpsb", color: "#000" }}
                              >
                                Issue Location-{" "}
                              </span>
                              {get(data, "centerState")}
                            </p>
                          ) : null} */}
                          {get(data, "centerDistrict") ? (
                            <p
                              className="issue-recipient"
                              style={{
                                fontFamily: "mpr",
                                color: "#2E2E2E"
                              }}
                            >
                              {get(data, "recipientGroupCategory") ==
                                "CENTRAL" ||
                              get(data, "recipientGroupCategory") ==
                                "CENTRAL_DEPARTMENT" ||
                              get(data, "recipientGroupCategory") == "OTHER" ? (
                                <span
                                  className="issue-category-title"
                                  style={{
                                    fontFamily: "mpsb",
                                    color: "#000"
                                  }}
                                >
                                  Issue District-{" "}
                                </span>
                              ) : (
                                <span
                                  className="issue-category-title"
                                  style={{
                                    fontFamily: "mpsb",
                                    color: "#000"
                                  }}
                                >
                                  Issue District/Department-{" "}
                                </span>
                              )}
                              {get(data, "centerDistrict")}
                            </p>
                          ) : null}

                          <p
                            className="issue-category"
                            style={{
                              fontFamily: "mpr",
                              marginTop:
                                get(projectData, "data.sponsoredByCategory") ===
                                "STATE"
                                  ? 0
                                  : 5
                            }}
                          >
                            <span
                              className="issue-category-title"
                              style={{ fontFamily: "mpsb", color: "#000" }}
                            >
                              Issue Category -{" "}
                            </span>
                            {get(data, "issueCategory", "NA")}
                          </p>
                          {get(data, "issueSubCategory") ? (
                            <p
                              className="issue-sub-category"
                              style={{ fontFamily: "mpr" }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Issue Sub-Category -{" "}
                              </span>
                              {get(data, "issueSubCategory", "NA")}
                            </p>
                          ) : null}
                          {get(data, "bucket.name") ? (
                            <p
                              className="issue-sub-category"
                              style={{ fontFamily: "mpr" }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Project Stage -{" "}
                              </span>
                              {get(data, "bucket.name", "NA")}
                            </p>
                          ) : null}
                          {get(data, "milestoneTable.name") ? (
                            <p
                              className="issue-sub-category"
                              style={{ fontFamily: "mpr" }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Phase -{" "}
                              </span>
                              {get(data, "milestoneTable.name", "NA")}
                              {get(data, "phaseName") ? " - " : ""}
                              {get(data, "phaseName", "")}
                            </p>
                          ) : null}
                          {get(data, "milestone.name") ? (
                            <p
                              className="issue-sub-category"
                              style={{ fontFamily: "mpr" }}
                            >
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Milestone -{" "}
                              </span>
                              {get(data, "milestone.name", "NA")}
                            </p>
                          ) : null}

                          {get(data, "proposalNoParivesh") ? (
                            <p className="issue-sub-category">
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Proposal No. (PARIVESH) -{" "}
                              </span>
                              <span
                                className="proposal-link"
                                onClick={this.showPraiveshModal}
                              >
                                {get(data, "proposalNoParivesh", "NA")}
                              </span>
                            </p>
                          ) : null}
                          {get(data, "forum") ? (
                            <p className="issue-sub-category">
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Forum -{" "}
                              </span>
                              {get(data, "forum.name", "NA")}
                            </p>
                          ) : null}
                          {get(data, "dateOfOrder") ? (
                            <p className="issue-sub-category">
                              <span
                                className="issue-category-title"
                                style={{
                                  fontFamily: "mpsb",
                                  color: "#000"
                                }}
                              >
                                Date of Order -{" "}
                              </span>
                              {dateFormat(get(data, "dateOfOrder", null))}
                            </p>
                          ) : null}
                        </div>
                        <div className="col-md-3" style={{ marginTop: 20 }}>
                          <div className="flex-box-wrapper">
                            {/* <DisplayByPermission
                            display={
                              get(permission, "updateIssue") &&
                              get(data, "edit") &&
                              get(data, "projectIssueDTO.status") !==
                                "ON_HOLD" &&
                              get(data, "projectIssueDTO.status") !==
                                "REJECTED" &&
                              !get(permission, "canViewOnlyProject")
                            }
                          >
                            <Button className="edit-btn" onClick={this.onShow}>
                              Edit
                            </Button>
                          </DisplayByPermission> */}
                            <div className="issue-list-status">
                              <div className="issue-list-status-inner">
                                <div className="issue-assignee">
                                  <b className="animated fadeInRight">
                                    {status === ISSUE_STATUS.REJECT ||
                                    status === ISSUE_STATUS.RESOLVED ||
                                    status === ISSUE_STATUS.REJECTED ||
                                    status === ISSUE_STATUS.HOLD ||
                                    status === ISSUE_STATUS.reject ||
                                    status === ISSUE_STATUS.resolved ||
                                    status === ISSUE_STATUS.hold ||
                                    status === ISSUE_STATUS["On Hold"] ? (
                                      status === ISSUE_STATUS.REJECT ||
                                      status === ISSUE_STATUS.reject ||
                                      status === ISSUE_STATUS.REJECTED ? (
                                        <>
                                          <span className="issue-assignee-title">
                                            Rejected by{" "}
                                          </span>
                                          <b>
                                            {get(
                                              data,
                                              "issueStatusChangeGroup"
                                            )}
                                          </b>
                                        </>
                                      ) : status === ISSUE_STATUS.RESOLVED ||
                                        status === ISSUE_STATUS.resolved ? (
                                        <>
                                          <span className="issue-assignee-title">
                                            Resolved by{" "}
                                          </span>
                                          <b>
                                            {get(
                                              data,
                                              "issueStatusChangeGroup"
                                            )}
                                          </b>
                                        </>
                                      ) : (
                                        <>
                                          <span className="issue-assignee-title">
                                            On Hold by{" "}
                                          </span>
                                          <b>
                                            {" "}
                                            {get(
                                              data,
                                              "issueStatusChangeGroup"
                                            )}
                                          </b>
                                        </>
                                      )
                                    ) : (
                                      <>
                                        <span className="issue-assignee-title">
                                          Assigned to{" "}
                                        </span>
                                        <b>{get(data, "assigneeGroup")}</b>
                                      </>
                                    )}
                                  </b>
                                </div>
                                <div className="issue-assign-date">
                                  <Image src={IconTime} alt="Time" />
                                  <span>
                                    {status === ISSUE_STATUS.REJECT ||
                                    status === ISSUE_STATUS.RESOLVED ||
                                    status === ISSUE_STATUS.HOLD ||
                                    status === ISSUE_STATUS.reject ||
                                    status === ISSUE_STATUS.REJECTED ||
                                    status === ISSUE_STATUS.resolved ||
                                    status === ISSUE_STATUS.hold ||
                                    status === ISSUE_STATUS["On Hold"]
                                      ? `on ${dateFormat(
                                          get(data, "issueStatusChangeDate")
                                        )}`
                                      : get(data, "lastAssigneeDate")
                                      ? dayAgo(get(data, "lastAssigneeDate"))
                                      : dayAgo(get(data, "createdDate"))}
                                  </span>
                                </div>
                              </div>
                              <OverlayTrigger
                                defaultShow={false}
                                placement="top"
                                overlay={
                                  <Tooltip className={"issues-status-tooltip"}>
                                    {toolttipDisplayMessage(status)}
                                  </Tooltip>
                                }
                              >
                                <div>
                                  <Button
                                    className={`btn-mod ${getColor(
                                      status
                                    )} animated flipY unClickable`}
                                    style={{ borderRadius: "20px" }}
                                  >
                                    {status}
                                  </Button>
                                </div>
                              </OverlayTrigger>
                            </div>
                          </div>
                          {get(data, "allowToViewNote") ? (
                            <IssueNoteModal IssueId={get(data, "id")} />
                          ) : null}
                        </div>
                      </div>
                      <span className="issue-desc-title">
                        Issue Description -
                      </span>
                      {get(projectData, "data.sponsoredByCategory") ===
                        "CENTRAL" ||
                      get(projectData, "data.sponsoredByCategory") === "PMG" ? (
                        <>
                          <p className="issue-description-section">
                            {get(data, "originalIssueTitle") ? (
                              <>
                                <p className="issue-original-tiltle-text">
                                  <span className="original-issue-title">
                                    Original Issue Title:{" "}
                                  </span>
                                  <span>
                                    {get(data, "originalIssueTitle", "NA")}
                                  </span>
                                </p>
                                <div className="issue-list-desc">
                                  <PreNode>
                                    <ReadMoreContent
                                      clamp={2}
                                      content={get(data, "description")}
                                      descriptionWeight={true}
                                    />
                                  </PreNode>
                                </div>
                              </>
                            ) : (
                              <div className="issue-list-desc-section">
                                <PreNode>
                                  <ReadMoreContent
                                    clamp={2}
                                    content={get(data, "description")}
                                    descriptionWeight={true}
                                  />
                                </PreNode>
                              </div>
                            )}
                          </p>
                        </>
                      ) : (
                        <div className="issue-list-desc-section">
                          <PreNode>
                            <ReadMoreContent
                              clamp={2}
                              content={get(data, "description")}
                              descriptionWeight={true}
                            />
                          </PreNode>
                        </div>
                      )}
                      {get(data, "originalIssueId") ? (
                        <p className="issue-recipient">
                          <span className="issue-category-title">
                            Original Issue -{" "}
                          </span>
                          <Link
                            to={{
                              pathname: PATHS.ISSUE_DETAIL,
                              search: `projectId=${projectId}&issueId=${get(
                                data,
                                "originalIssueId"
                              )}`
                            }}
                          >
                            #{get(data, "originalIssueId")}
                          </Link>
                        </p>
                      ) : null}
                      {get(data, "duplicateIssues") &&
                      get(data, "duplicateIssues").length ? (
                        <p className="issue-recipient">
                          <span className="issue-category-title">
                            Duplicate Issue(s) -{" "}
                          </span>
                          {get(data, "duplicateIssues").map((item, index) => {
                            let separator =
                              index < get(data, "duplicateIssues").length - 1
                                ? ","
                                : null;
                            return (
                              <span key={index}>
                                <Link
                                  to={{
                                    pathname: PATHS.ISSUE_DETAIL,
                                    search: `projectId=${projectId}&issueId=${item}`
                                  }}
                                >
                                  #{item}
                                </Link>
                                {separator}
                                &nbsp;
                              </span>
                            );
                          })}
                        </p>
                      ) : null}
                      <div className="issue-detail-section attachment-added">
                        <DisplayPopUpAttachments
                          filesArr={get(data, "files", [])}
                          addAttchementRequired={false}
                          removeRequired={false}
                          classes="attachments"
                        />
                      </div>
                      {/* <AgendaIssuePragatiReview
                        isPragati={get(data, "issuePragatiReview")}
                        className="issue_detail_pragati_flag"
                      /> */}

                      {isPragatiReview ? (
                        <AgendaIssuePragatiReview
                          isPragati={isPragatiReview}
                          className="issue_detail_pragati_flag"
                        />
                      ) : isPragatiPipeline ? (
                        <AgendaIssuePragatiPipeline
                          isPragatiPipeline={isPragatiPipeline}
                          className="issue_detail_pipeline_flag"
                        />
                      ) : null}
                      <div className="created-by issue-detail-created-by">
                        <span
                          className={`issue-created-by ${get(
                            data,
                            "creatorVerified"
                          ) && "verified-user"}`}
                        />
                        <span className="first-pp-name">
                          <RedirectUser
                            title={get(data, "issueCreatorName", "NA")}
                            id={
                              isUserPMG
                                ? get(data, "previousCreatedBy.id", "NA")
                                : get(data, "issueCreatorId", "NA")
                            }
                          />
                        </span>
                        <span className="seperator">|</span>
                        <span className="issue-created-on">
                          {get(data, "verificationDate")
                            ? `Verified on
                            ${dateFormat(get(data, "verificationDate", null))}
                          `
                            : `
                          Created on
                            ${dateFormat(get(data, "createdDate", null))}
                          `}
                        </span>
                        {/* <div className="attachment-added">
                          <DisplayAttachments
                            filesArr={get(data, "files", [])}
                            addAttchementRequired={false}
                            removeRequired={false}
                            classes="attachments"
                          />
                        </div> */}
                      </div>
                      <DisplayByPermission
                        display={!get(permission, "canViewOnlyIssues")}
                      >
                        <div className="issue-actions issue-list-action detail-action">
                          {data ? (
                            <>
                              <IssueAction
                                resetAction={resetAction}
                                issueDetails={{
                                  ...data,
                                  project: projectData ? projectData.data : {}
                                }}
                                defaultOpen={true}
                                handleOnClick={this.handleOnClick}
                                callApiOnSuccess={() => {
                                  this.awakeSideBar();
                                  this.initialApiCall();
                                  this.getIssueDetail();
                                  this.getIssueListData();
                                  getProjectTimelineData(projectId);
                                }}
                                onCloseButton={this.handleButtonClose}
                                markDuplicateBTN={this.state.markbtndisplay}
                              />
                              <DisplayByPermission
                                display={
                                  get(permission, "updateIssue") &&
                                  get(data, "edit") &&
                                  get(data, "projectIssueDTO.status") !==
                                    "ON_HOLD" &&
                                  get(data, "projectIssueDTO.status") !==
                                    "REJECTED" &&
                                  !get(permission, "canViewOnlyProject")
                                }
                              >
                                <ToolTip text={MESSAGES_CONSTANT["EditIssue"]}>
                                  <Button
                                    style={{
                                      display:
                                        this.state.displayButtons == 1
                                          ? "none"
                                          : null
                                    }}
                                    className={`new-editdecision-btn no-padding-new shadow-none align-self-end`}
                                    onClick={this.onShow}
                                  >
                                    <img
                                      src={NewPencilIcon}
                                      className="newpencilicon"
                                    />{" "}
                                    Edit Issue
                                  </Button>
                                </ToolTip>
                              </DisplayByPermission>
                              <IssueUpdateStatus
                                resetAction={resetAction}
                                issueDetails={{
                                  ...data,
                                  project: projectData ? projectData.data : {}
                                }}
                                Displaybuttons={this.state.displayButtons}
                                callApiOnSuccess={() => {
                                  this.awakeSideBar();
                                  this.initialApiCall();
                                  this.getIssueDetail();
                                  this.getIssueListData();
                                  getProjectTimelineData(projectId);
                                }}
                                onCloseButton={this.handleButtonClose}
                                markDuplicateBTN={this.handleMarkBTN}
                                issueStatus={
                                  get(data, "projectIssueDTO.status") ==
                                    "ON_HOLD" ||
                                  get(data, "projectIssueDTO.status") ==
                                    "REJECTED"
                                    ? true
                                    : false
                                }
                                marginleft={false}
                                AdminCredential={this.state.admincredential}
                              />
                              {/* <MarkDuplicatebtn
                         resetAction={resetAction}
                         issueDetails={{
                           ...data,
                           project: projectData ? projectData.data : {}
                         }}   
                         Displaybuttons={this.state.displayButtons}
                         callApiOnSuccess={() => {
                           this.awakeSideBar();
                           this.initialApiCall();
                           this.getIssueDetail();
                           this.getIssueListData();
                           getProjectTimelineData(projectId);
                         }}
                         onCloseButton={this.handleButtonClose}
                         markDuplicateBTN={this.handleMarkBTN}
                         /> */}
                            </>
                          ) : null}
                        </div>
                      </DisplayByPermission>
                      {isValidArray(get(data, "childs")) ? (
                        <div className="row" style={{ marginLeft: "0px" }}>
                          <div className="heading-child-issue">
                            Child Issue(s){" "}
                            <TooltipComponent
                              classes="create_project_tolltip vertical-align align-right"
                              content={
                                <>
                                  Issues forwarded to the concerned
                                  Departments/Districts
                                </>
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <DisplayByPermission
                        display={isValidArray(get(data, "childs"))}
                      >
                        <div
                          className={`forwarded-to-team ${
                            get(permission, "canViewOnlyProject")
                              ? "forwarded-view-only"
                              : ""
                          }`}
                          style={{
                            border: "1px solid #E3DADA",
                            marginBottom: "36px"
                          }}
                        >
                          <ForwardToTeamChilds
                            childs={get(data, "childs")}
                            issueDetails={data}
                            createdBy={createdBy}
                            isChilds={true}
                          />
                        </div>
                      </DisplayByPermission>
                      {/* <div className="mom-wrapper accordion-wrapper">
                        {" "}
                        {/* {isValidArray(_meetingDecisionDTOS) ? (
                          <h2 className="accordion-heading">
                            {ISSUE_DECISION_DETAILS.MOM_HEADER_TITLE}{" "}
                            <span>({_meetingDecisionDTOS.length})</span>
                          </h2>
                        ) : null} */}
                      {/* <div className="meetings_old_section">
                          <span className="meetings_old">
                            Meeting Decisions Have Moved To The Issue Progress
                            Timeline.{" "}
                          </span>
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              this.startIntroTour();
                            }}
                          >
                            Click Here
                          </a>{" "}
                          To Check!
                        </div> */}
                      {/* Commented the old decision section here */}
                      {/* {(isValidArray(_meetingDecisionDTOS) &&
                          _meetingDecisionDTOS.map((list, index) => (
                            <MOM
                              momDesc="true"
                              meetingDecisionDTOS={list}
                              key={`mom-${index}`}
                            />
                          ))) ||
                          null} */}
                      {/* </div> */}
                    </div>
                  </Col>
                )}
                <Col lg={4} className="issue-sidebar">
                  <LinkContext.Provider value={this.decisionRef}>
                    <IssueDetailsSideBar
                      upcomingMOM={upcomingMOM}
                      awakeSideBar={awakeSideBar}
                      meetingDecisions={_meetingDecisionDTOS}
                      issueDetailId={issueId}
                    />
                  </LinkContext.Provider>
                </Col>
              </Row>
            </Container>
          </div>

          <div
            className="more-issue-wrapper border-top-more-issue"
            ref={this.issueListContainer}
          >
            <div className="small-container">
              {issueListApiStatus === STATUS.LOADING ||
              isValidArray(listDTO) ? (
                <React.Fragment>
                  <h2>
                    <span className="more-issue-count">
                      {get(issueListDTO, "total", 1) - 1}
                    </span>
                    <span className="more-issue-title"> more issues</span>
                    <span className="more-issue-text"> in this project</span>
                  </h2>
                  <IssueListWitLoader
                    issueList={listDTO}
                    isLoading={issueListApiStatus}
                    paginationNo={paginationNo}
                    permission={permission}
                    callApiOnSuccess={this.getIssueListData}
                  />
                  <Pagination
                    offset={issueListParams.offset}
                    onPageChange={this.onPageChange}
                    pageCount={
                      get(issueListDTO, "total", 0) /
                      get(issueListDTO, "limit", 0)
                    }
                  />
                </React.Fragment>
              ) : null}
              {get(projectData, "data.addMoreIssue") &&
              !get(permission, "canViewOnlyIssues") ? (
                <div
                  className="add-more-issue-wrapper"
                  ref={elem => {
                    this.addIssueWrapper = elem;
                  }}
                >
                  {" "}
                  <AddIssue
                    showLanguageError={this.state.showLanguageError}
                    title="Add Issue"
                    issueSaved={issueSaved}
                    handleProposalChange={this.handleProposalChange}
                    params={{
                      show: get(data, "displayAutocomplete"),
                      allowOnCreate: get(data, "allowOnCreate"),
                      resetForm: resetForm,
                      error: error.issuesError,
                      errorCOListError: error.issueCOListError,
                      initialRequiredFields: initialRequiredFields,
                      updateParentState: this.updateParentState,
                      updateParentStateError: this.updateParentStateError,
                      resetIssue: this.resetAddIssue,
                      addIssueErrorUpdate: this.addIssueErrorUpdate,
                      isProjectAwardedByState:
                        get(projectData, "data.sponsoredByCategory") ===
                        GROUP_KEYS.STATE,
                      parentGroupId: get(
                        projectData,
                        "data.sponsoredByid",
                        null
                      ),
                      selectedOptionImageUrl: get(
                        projectData,
                        "data.sponsoredByImageUrl",
                        null
                      ),
                      workflowType: get(projectData, "data.workflowType"),
                      projectPPList: get(projectData, "data.projectPPList"),
                      createdBy: createdBy,
                      projectID: get(projectData, "data.id", null)
                    }}
                    onValidateForm={this.onValidateForm}
                    onRemoveFileDetail={this.onRemoveFile}
                  />
                  {/* <Button className="btn-orange" onClick={this.onValidateForm}>
                    SUBMIT FOR VERIFICATION
                  </Button> */}
                </div>
              ) : null}
            </div>
          </div>
          <DisplayByPermission display={isPariveshModalVisible}>
            <PariveshData
              show={isPariveshModalVisible}
              closeModal={this.closePariveshModal}
              issueSubCategoryId={this.state.selectedIssueSubCategoryId}
              proposalNoParivesh={this.state.selectedProposalNoParivesh}
            />
          </DisplayByPermission>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueData: state.issueDetailsReducer.issueData,
    loading: state.projectDetailsReducer.projectDetailsStatus,
    issueDetailsStatus: state.issueDetailsReducer.issueDetailsStatus,
    projectDetailsStatus: state.projectDetailsReducer.projectDetailsStatus,
    projectData: state.projectDetailsReducer.projectData,
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssueDetails: getIssueDetails,
      // getIssueList: getIssueList,
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction,
      createIssueDispatch: createIssueAction,
      postCommentDispatch: postCommentAction,
      getProjectDetails,
      getProjectTimelineData
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(IssueDetailPage)
  )
);
